import React from 'react'
import { Link } from 'react-router-dom'

function SectionCard(props) {

    const { section } = props;

    return (
        <div>
            <div
                className="card shadow border-0 my-2"
                style={{ backgroundColor: "#33383a" }}
            >
                <div className="card-body py-3 py-lg-5">
                    <div
                        className="card-title h5 fw-light font-monospace"
                        style={{ color: "#d3d8da" }}
                    >
                        {section.sectionName}
                    </div>
                </div>
                <Link to={section.linkToSection} className="stretched-link"></Link>
            </div>
        </div>
    )
}

export default SectionCard;

//{`${section.linkToSection}/${section.sectionName}`}